import React from 'react';
import {classes, style} from './doppe-viewer-content-modal.st.css';
import {DoppeViewerModalPanel, DoppeViewerModalPanelLayout} from '../doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {BymoPageStyleScopeContext} from '../bymo-page-style/bymo-page-style';
import {flexColumn, flexFillRemainingVerticalSpace, reactCreateMemo} from '@wix/devzai-utils-react';
import {ObservableValue, uiPartsGroupCreateMarking} from '@wix/devzai-utils-common';
import {WidgetRenderingContextType} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeViewerWidgetRenderingScope
} from '../doppe-viewer-widget-rendering-context/doppe-viewer-widget-rendering-context';
import {
    DoppeViewerModalContent,
    DoppeViewerModalContentRenderer
} from '../doppe-viewer-modals-controller/doppe-viewer-modals-controller';
import {DoppeViewerModalPanelHeader} from '../doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header';
import {DoppeViewerHorizontalButton} from '../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button';
import {DoppeViewerAppIconDismissMedium} from '../doppe-viewer-icons/doppe-viewer-icons';
import {DoppePageViewerPartsGroups} from '../doppe-page-viewer-part/doppe-page-viewer-part';
import {BymoPageStyleScope} from "../../client-server-common";

export const DoppeViewerContentModal = reactCreateMemo(function DoppeViewerContentModal(
    props: DoppeViewerContentModal.Props
) {
    const {
        title,
        closeCallback,
        mobileLayout = DoppeViewerModalPanelLayout.FullScreen,
        desktopLayout = DoppeViewerModalPanelLayout.Inner,
        content,
        showHeader = true,
        showHeaderAsCloseButton = false
    } = props;

    return (
        <BymoPageStyleScopeContext.Provider
            value={BymoPageStyleScope.Popup}
        >
            <DoppeViewerWidgetRenderingScope
                widgetRenderingContextType={WidgetRenderingContextType.Modal}
                renderingInnerStateController={new ObservableValue(false)}
                isFullScreen={true}
                closeCallback={closeCallback}
                headerCustomSettings={{
                    title: title,
                    dismissButtonCallback: closeCallback
                }}
            >
                <DoppeViewerModalPanel
                    className={flexColumn()}
                    mobileLayout={mobileLayout}
                    desktopLayout={desktopLayout}
                >
                    {
                        showHeader ?
                            showHeaderAsCloseButton && closeCallback ?
                                <DoppeViewerHorizontalButton
                                    className={style(classes.dismissButton, {})}
                                    prefixIcon={DoppeViewerAppIconDismissMedium}
                                    textual={true}
                                    {...uiPartsGroupCreateMarking(DoppePageViewerPartsGroups.CloseButton)}
                                    onClick={() => {
                                        closeCallback();
                                    }}
                                />
                                :
                                <DoppeViewerModalPanelHeader
                                    title={title}
                                    dismissButtonCallback={() => {
                                        closeCallback?.();
                                    }}
                                />
                        :
                        null
                    }
                    <div
                        className={style(classes.contentContainer, {}, flexFillRemainingVerticalSpace())}
                    >
                        <DoppeViewerModalContentRenderer>
                            {content}
                        </DoppeViewerModalContentRenderer>
                    </div>
                </DoppeViewerModalPanel>
            </DoppeViewerWidgetRenderingScope>

        </BymoPageStyleScopeContext.Provider>
    )
});

export namespace DoppeViewerContentModal {

    export interface Props {
        closeCallback?: () => void;
        mobileLayout?: DoppeViewerModalPanelLayout;
        desktopLayout?: DoppeViewerModalPanelLayout;
        title: string;
        content: DoppeViewerModalContent,
        showHeader?: boolean;
        showHeaderAsCloseButton?: boolean;
    }

}